import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { LoadingButton as MuiLoadingButton } from '@mui/lab';
import { Button, ButtonProps, IconButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Icons } from 'greener-ui-library';
import { AddButtonProps, LoadingButtonProps } from './buttons.types';

export const LoadingButton = ({ loading, children, ...props }: LoadingButtonProps) => {
  return (
    <MuiLoadingButton loading={loading} variant="contained" color="primary" data-testid="loading-button" {...props}>
      {children}
    </MuiLoadingButton>
  );
};

export function AddButton({ onClick, children, ...props }: AddButtonProps) {
  const { t } = useTranslation();

  const buttonContent = children ? children : t('components:form.add');

  return (
    <Button
      onClick={onClick}
      data-testid="add-button"
      variant="contained"
      color="primary"
      startIcon={<Icons.Plus fill="currentColor" />}
      {...props}
    >
      {buttonContent}
    </Button>
  );
}

/**
 * Button that display text or not based on the given breakpoint
 */
export const ResponsiveButton = ({
  icon: Icon,
  breakpoint = 'xs',
  children,
  ...rest
}: {
  icon: () => ReactNode;
  breakpoint?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  children: ReactNode;
} & Partial<ButtonProps>) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up(breakpoint));

  return matches ? (
    <Button
      {...rest}
      startIcon={<Icon />}
      sx={{
        fontSize: 12,
      }}
    >
      {children}
    </Button>
  ) : (
    <IconButton {...rest}>
      <Icon />
    </IconButton>
  );
};
